/**
 * Product Attributes Constants
 * Generated from WordPress database on 2025-09-25T18:10:02.218Z
 *
 * These constants are used throughout the frontend for:
 * - Search filters
 * - Form dropdowns
 * - Product display
 * - Data validation
 */

// Brand options (120 brands)
export const BRANDS = [
  { value: 'other-stories', label: '& Other Stories' },
  { value: 'aday', label: 'ADAY' },
  { value: 'aeyde', label: 'Aeyde' },
  { value: 'agolde', label: 'AGOLDE' },
  { value: 'aje', label: 'Aje' },
  { value: 'alexander-mcqueen', label: 'Alexander McQueen' },
  { value: 'alexandre-birman', label: 'Alexandre Birman' },
  { value: 'alice-olivia', label: 'Alice + Olivia' },
  { value: 'ally-shoes', label: 'ALLY Shoes' },
  { value: 'alo-yoga', label: 'Alo Yoga' },
  { value: 'aqua', label: 'AQUA' },
  { value: 'aquatalia', label: 'Aquatalia' },
  { value: 'aritzia', label: 'Aritzia' },
  { value: 'bash', label: 'Ba&sh' },
  { value: 'barbour', label: 'Barbour' },
  { value: 'bee-and-kin', label: 'Bee and Kin' },
  { value: 'bobbies', label: 'Bobbies' },
  { value: 'bottega-veneta', label: 'Bottega Veneta' },
  { value: 'buffbunny', label: 'Buffbunny' },
  { value: 'cartier', label: 'Cartier' },
  { value: 'casadei', label: 'Casadei' },
  { value: 'catherine-gee', label: 'Catherine Gee' },
  { value: 'celine', label: 'Celine' },
  { value: 'chanel', label: 'Chanel' },
  { value: 'charo-ruiz', label: 'Charo Ruiz' },
  { value: 'chloe', label: 'Chloe' },
  { value: 'claudie-pierlot', label: 'Claudie Pierlot' },
  { value: 'cole-haan', label: 'Cole Haan' },
  { value: 'commando', label: 'Commando' },
  { value: 'cos', label: 'COS' },
  { value: 'crocs', label: 'Crocs' },
  { value: 'cyrillus', label: 'Cyrillus' },
  { value: 'dandy-del-mar', label: 'Dandy Del Mar' },
  { value: 'diana-milkanova-studio', label: 'Diana Milkanova Studio' },
  { value: 'dior', label: 'Dior' },
  { value: 'doen', label: 'Doen' },
  { value: 'dragon-diffusion', label: 'Dragon Diffusion' },
  { value: 'everlane', label: 'Everlane' },
  { value: 'farm-rio', label: 'Farm Rio' },
  { value: 'fleur-du-mal', label: 'Fleur Du Mal' },
  { value: 'frye', label: 'Frye' },
  { value: 'gaala', label: 'GAALA' },
  { value: 'ganni', label: 'GANNI' },
  { value: 'germaine-guerin', label: 'Germaine Guerin' },
  { value: 'gianvito-rossi', label: 'Gianvito Rossi' },
  { value: 'gucci', label: 'Gucci' },
  { value: 'hai', label: 'Hai' },
  { value: 'hermes', label: 'Hermes' },
  { value: 'iris-ink', label: 'IRIS & INK' },
  { value: 'jimmy-choo', label: 'Jimmy Choo' },
  { value: 'joah-brown', label: 'Joah Brown' },
  { value: 'karen-millen', label: 'Karen Millen' },
  { value: 'keyahri', label: 'Keyahri' },
  { value: 'lagence', label: "L'Agence" },
  { value: "l'agence", label: "L'Agence" },
  { value: 'lanvin', label: 'Lanvin' },
  { value: 'le-tanneur', label: 'Le Tanneur' },
  { value: 'lea-poesie', label: 'LEA Poesie' },
  { value: 'lk-bennett', label: 'LK Bennett' },
  { value: 'loewe', label: 'LOEWE' },
  { value: 'londre', label: 'Londre' },
  { value: 'loro-piana', label: 'Loro Piana' },
  { value: 'lululemon', label: 'Lululemon' },
  { value: 'maje', label: 'Maje' },
  { value: 'manolo-blahnik', label: 'Manolo Blahnik' },
  { value: 'mansur-gavriel', label: 'Mansur Gavriel' },
  { value: 'margaux', label: 'Margaux' },
  { value: 'mark-cross', label: 'Mark Cross' },
  { value: 'marni', label: 'Marni' },
  { value: 'max-mara-weekend', label: 'Max Mara Weekend' },
  { value: 'me-em', label: 'Me + Em' },
  { value: 'melanie-casey', label: 'Melanie Casey' },
  { value: 'min-and-mon', label: 'Min and Mon' },
  { value: 'mm-lafleur', label: 'MM Lafleur' },
  { value: 'moynat', label: 'MOYNAT' },
  { value: 'nation-ltd', label: 'Nation LTD' },
  { value: 'oneone-swimwear', label: 'OneOne Swimwear' },
  { value: 'patrick-cupid', label: 'Patrick Cupid' },
  { value: 'paul-smith', label: 'Paul Smith' },
  { value: 'polene', label: 'Polene' },
  { value: 'prada', label: 'Prada' },
  { value: 'ramy-brook', label: 'Ramy Brook' },
  { value: 'reformation', label: 'Reformation' },
  { value: 'reiss', label: 'REISS' },
  { value: 'reqin', label: 'Reqin' },
  { value: 'rick-owens', label: 'Rick Owens' },
  { value: 'roger-vivier', label: 'Roger Vivier' },
  { value: 'rouje', label: 'Rouje' },
  { value: 'saint-laurent', label: 'Saint Laurent' },
  { value: 'saloni', label: 'Saloni' },
  { value: 'samantha-pleet', label: 'Samantha Pleet' },
  { value: 'sandro', label: 'Sandro' },
  { value: 'sarah-flint', label: 'Sarah Flint' },
  { value: 'sartore', label: 'Sartore' },
  { value: 'scanlan-theodore', label: 'Scanlan Theodore' },
  { value: 'self-portrait', label: 'Self Portrait' },
  { value: 'senreve', label: 'Senreve' },
  { value: 'sezane', label: 'Sezane' },
  { value: 'skims', label: 'Skims' },
  { value: 'spanx', label: 'Spanx' },
  { value: 'staud', label: 'STAUD' },
  { value: 'stuart-weitzman', label: 'Stuart Weitzman' },
  { value: 'tamara-mellon', label: 'Tamara Mellon' },
  { value: 'ted-baker', label: 'Ted Baker' },
  { value: 'the-fold', label: 'The Fold' },
  { value: 'the-kit', label: 'The kit' },
  { value: 'the-kooples', label: 'The Kooples' },
  { value: 'tiffany', label: 'Tiffany' },
  { value: 'tods', label: "Tod's" },
  { value: 'tom-ford', label: 'Tom Ford' },
  { value: 'tory-burch', label: 'Tory Burch' },
  { value: 'toteme', label: 'Toteme' },
  { value: 'valentino-garavani', label: 'Valentino Garavani' },
  { value: 'veja', label: 'Veja' },
  { value: 'veronica-beard', label: 'Veronica Beard' },
  { value: 'vetchy', label: 'Vetchy' },
  { value: 'vivienne-westwood', label: 'Vivienne Westwood' },
  { value: 'vuori', label: 'Vuori' },
  { value: 'wild-donkey', label: 'Wild Donkey' },
  { value: 'zimmerman', label: 'Zimmerman' },
];

// Clothing size options (22 sizes)
export const CLOTHING_SIZES = [
  { value: '4', label: '4', count: 1 },
  { value: 'm', label: 'M', count: 1 },
  { value: 's', label: 'S', count: 1 },
  { value: 'size-0', label: 'Size 0', count: 7 },
  { value: 'size-10', label: 'Size 10', count: 20 },
  { value: 'size-12', label: 'Size 12', count: 8 },
  { value: 'size-14', label: 'Size 14', count: 2 },
  { value: 'size-2', label: 'Size 2', count: 69 },
  { value: 'size-27', label: 'Size 27', count: 4 },
  { value: 'size-28', label: 'Size 28', count: 1 },
  { value: 'size-29', label: 'Size 29', count: 2 },
  { value: 'size-4', label: 'Size 4', count: 107 },
  { value: 'size-6', label: 'Size 6', count: 102 },
  { value: 'size-7', label: 'Size 7', count: 4 },
  { value: 'size-8', label: 'Size 8', count: 37 },
  { value: 'size-l', label: 'Size L', count: 16 },
  { value: 'size-m', label: 'Size M', count: 57 },
  { value: 'size-s', label: 'Size S', count: 143 },
  { value: 'size-xl', label: 'Size XL', count: 4 },
  { value: 'size-xs', label: 'Size XS', count: 78 },
  { value: 'size-xxl', label: 'Size XXL', count: 1 },
  { value: 'size-xxs', label: 'Size XXS', count: 13 },
];

// Shoe size options (16 sizes)
export const SHOE_SIZES = [
  { value: '8-5', label: '8.5', count: 1 },
  { value: 'shoe-size-10', label: 'Shoe Size 10', count: 3 },
  { value: 'shoe-size-11', label: 'Shoe Size 11', count: 1 },
  { value: 'shoe-size-5', label: 'Shoe Size 5', count: 1 },
  { value: 'shoe-size-6', label: 'Shoe Size 6', count: 1 },
  { value: 'shoe-size-6-5', label: 'Shoe Size 6.5', count: 3 },
  { value: 'shoe-size-7', label: 'Shoe Size 7', count: 6 },
  { value: 'shoe-size-7-5', label: 'Shoe Size 7.5', count: 7 },
  { value: 'shoe-size-8', label: 'Shoe Size 8', count: 16 },
  { value: 'shoe-size-8-5', label: 'Shoe Size 8.5', count: 1 },
  { value: 'shoe-size-9', label: 'Shoe Size 9', count: 6 },
  { value: 'shoe-size-9-5', label: 'Shoe Size 9.5', count: 4 },
  { value: 'shoes-size-7-5', label: 'Shoes Size 7.5', count: 1 },
  { value: 'size-5-5', label: 'Size 5.5', count: 1 },
  { value: 'size-6-5', label: 'Size 6.5', count: 4 },
  { value: 'size-7-5', label: 'Size 7.5', count: 6 },
];

// Color options (6 colors)
export const COLORS = [
  { value: 'black', label: 'Black', count: 6 },
  { value: 'burgundy', label: 'Burgundy', count: 1 },
  { value: 'ivory', label: 'Ivory', count: 1 },
  { value: 'navy', label: 'Navy', count: 2 },
  { value: 'pink', label: 'Pink', count: 1 },
  { value: 'white', label: 'White', count: 1 },
];

// Product type options (24 types)
export const PRODUCT_TYPES = [
  { value: 'bag', label: 'Bag', count: 36 },
  { value: 'bikini', label: 'Bikini', count: 2 },
  { value: 'blazer', label: 'Blazer', count: 21 },
  { value: 'blouse', label: 'Blouse', count: 52 },
  { value: 'bodysuit', label: 'Bodysuit', count: 5 },
  { value: 'boots', label: 'Boots', count: 12 },
  { value: 'cardigan', label: 'Cardigan', count: 46 },
  { value: 'coat', label: 'Coat', count: 16 },
  { value: 'dress', label: 'Dress', count: 172 },
  { value: 'jacket', label: 'Jacket', count: 12 },
  { value: 'jewelry', label: 'Jewelry', count: 10 },
  { value: 'jumpsuit', label: 'Jumpsuit', count: 4 },
  { value: 'leggings', label: 'Leggings', count: 6 },
  { value: 'pants', label: 'Pants', count: 38 },
  { value: 'romper', label: 'Romper', count: 6 },
  { value: 'sandals', label: 'Sandals', count: 12 },
  { value: 'scarf', label: 'Scarf', count: 1 },
  { value: 'shoes', label: 'Shoes', count: 72 },
  { value: 'shorts', label: 'Shorts', count: 18 },
  { value: 'skirt', label: 'Skirt', count: 52 },
  { value: 't-shirt', label: 'T-shirt', count: 13 },
  { value: 'tank', label: 'Tank', count: 15 },
  { value: 'tee', label: 'Tee', count: 3 },
  { value: 'trench', label: 'Trench', count: 13 },
];

// Height range options (8 ranges)
export const HEIGHT_RANGES = [
  { value: "5'0", label: "<5'0", count: 0 },
  { value: "5'1-5'2", label: "5'1-5'2", count: 83 },
  { value: "5'3-5'4", label: "5'3-5'4", count: 194 },
  { value: "5'5-5'6", label: "5'5-5'6", count: 343 },
  { value: "5'7-5'8", label: "5'7-5'8", count: 60 },
  { value: "5'9-5'10", label: "5'9-5'10", count: 26 },
  { value: "5'11", label: "5'11+", count: 10 },
];

// Material options (1 materials)
export const MATERIALS = [{ value: 'denim', label: 'Denim', count: 14 }];

// All colors as simple array for quick lookups
export const COLOR_SLUGS = ['black', 'burgundy', 'ivory', 'navy', 'pink', 'white'];

// Helper functions
export const getBrandBySlug = slug => BRANDS.find(brand => brand.value === slug);
export const getColorBySlug = slug => COLORS.find(color => color.value === slug);
export const getSizeBySlug = slug =>
  [...CLOTHING_SIZES, ...SHOE_SIZES].find(size => size.value === slug);
export const getProductTypeBySlug = slug => PRODUCT_TYPES.find(type => type.value === slug);

// Validation functions
export const isValidBrand = slug => BRANDS.map(b => b.value).includes(slug);
export const isValidColor = slug => COLOR_SLUGS.includes(slug);
